<template>
  <div>
    <h3>Wählen Sie das Property, an dem Sie sich gerade befinden.</h3>
    <el-select v-model="selected" placeholder="Wählen Sie Ihren Standort">
      <el-option
        v-for="item in properties"
        :key="item.code"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-button @click="next()">Weiter</el-button>
    <!-- {{ properties }} -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      properties: null,
      tokenMan: null,
      selected: null
    }
  },
  computed: {
    ...mapGetters({
      token: 'getAuthToken'
    })
  },
  methods: {
    getProperties () {
      const apiURL = 'https://api.apaleo.com/inventory/v1/properties'
      const auth = this.token
      axios.get(apiURL, { headers: { 'Authorization': auth } })
        .then(response => {
          this.properties = response.data.properties
        })
        .catch(error => {
          console.log(error)
        })
    },
    storeProperty () {
      console.log('selected property:', this.selected)
      this.$store.commit('setProperty', this.selected)
    },
    next () {
      this.storeProperty()
      this.$router.push('/table')
    }
  },
  mounted () {
    this.getProperties()
    this.$message.success('Willkommen im Klingenschildsystem!')
  }
}
</script>
